import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import RouteOutlinedIcon from "@mui/icons-material/RouteOutlined";
import SmartphoneOutlinedIcon from "@mui/icons-material/SmartphoneOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import OndemandVideoOutlinedIcon from "@mui/icons-material/OndemandVideoOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import LandingSectionHeader from "./LandingSectionHeader";
import { CREATION_FORMATS } from "./landingCreationFormats";
import "./LandingProductDetailsSection.css";
import "./LandingCreationSection.css";

const PRODUCT_DETAILS = [
  {
    id: "knowledge_base",
    name: "База знаний",
    icon: <MenuBookOutlinedIcon />,
    title: "Карманная подсказка: ответ на любой вопрос в твоём кармане",
    lead:
      "Рабочие инструкции легко забыть, наставник не всегда рядом, а правильный ответ может вылететь из головы в нужный момент. В базе знаний вы фиксируете ответы на типовые вопросы и ситуации — сотрудник всегда может найти правильный ответ в базе знаний.",
    features: [
      "Ситуация и правильная реакция: например, бариста — что ответить, если гость говорит, что кофе сделан неправильно",
      "Новое оборудование: похоже на старое, но с особенностями — через базу донесёте инструкцию до всех заинтересованных сотрудников",
      "HR задаёт стандарт один раз — вся команда получает одинаковую информацию",
      "Не нужно искать в чатах и папках — открыл бота, выбрал ситуацию, получил ответ",
    ],
    highlight: {
      icon: <SmartphoneOutlinedIcon />,
      text: "Подсказка всегда в кармане — на смене, в зале, на объекте, когда наставника рядом нет.",
    },
    accent: "kb",
    previewEditorLabel: "Редактор базы знаний",
    previewBotLabel: "Как видит сотрудник в боте",
  },
  {
    id: "scenario",
    name: "Сценарий",
    icon: <AccountTreeOutlinedIcon />,
    title: "Интерактивное обучение: решение сотрудника меняет ход событий",
    lead:
      "Сотрудник не просто смотрит запись — он принимает решения, и от каждого ответа зависит, что будет дальше. Разные реакции, разные исходы — как в реальной рабочей ситуации.",
    features: [
      "Сотрудник выбирает вариант действия — сценарий реагирует по-разному",
      "Пример для продаж: менеджер общается с клиентом и одними решениями приходит к успешной сделке, другими — нет",
      "Подходит для онбординга, продаж, сервиса, compliance и отработки типовых кейсов",
      "Помогает готовиться и к нестандартным ситуациям — когда нет готового регламента, но нужно принять верное решение",
    ],
    highlight: {
      icon: <RouteOutlinedIcon />,
      text: "HR видит, как команда проходит программу, и понимает, где люди «спотыкаются» на сложных решениях.",
    },
    accent: "scenario",
    previewEditorLabel: "Редактор сценария",
    previewBotLabel: "Как видит сотрудник в боте",
  },
  {
    id: "trainer",
    name: "Тренажёр",
    icon: <QuizOutlinedIcon />,
    title: "Тренажёр: прокачка навыков и дополнительная мотивация",
    lead:
      "Инструмент помогает закрепить знания и повышать свой уровень компетенций. Сотрудник отвечает на вопросы, сразу видит результат — а HR получает картину по команде.",
    features: [
      "Мгновенная обратная связь: сразу видно, усвоил ли сотрудник тему",
      "Рейтинг и аналитика — кто лидирует, где команда ошибается чаще всего",
      "Дополнительная мотивация: ачивки за прохождение, бонусы за первые места — «занимайся, получишь приз»",
      "Проверка после обучения — понятно, кто готов к работе, а кому нужна поддержка",
    ],
    highlight: {
      icon: <EmojiEventsOutlinedIcon />,
      text: "Лучшие в рейтинге тренажёра — повод для поощрения: ачивка, благодарность или бонус от руководителя.",
    },
    accent: "trainer",
    previewEditorLabel: "Редактор тренажёра",
    previewBotLabel: "Как видит сотрудник в боте",
  },
];

const formatPreviews = Object.fromEntries(
  CREATION_FORMATS.map((format) => [format.id, format])
);

export default function LandingProductDetailsSection() {
  return (
    <section
      id="products"
      className="landing-band landing-band--products-detail landing-section landing-section--products-detail"
    >
      <div className="landing-container">
        <LandingSectionHeader
          label="02 · Продукты"
          title="Наши инструменты"
          desc="Разбираем каждый инструмент на примерах из реальной работы: ответы на смене, обучение через решения и проверка знаний команды."
        />

        <div className="landing-content-format">
          <div className="landing-content-format__icon">
            <ArticleOutlinedIcon />
            <OndemandVideoOutlinedIcon />
          </div>
          <div>
            <h3 className="landing-content-format__title">
              Контент текстом или видео — во всех инструментах
            </h3>
            <p className="landing-content-format__desc">
              В базе знаний, сценарии и тренажёре материалы можно оформить
              коротким текстом или видео. Вы сами выбираете формат, который
              лучше объясняет задачу — без технических ограничений и лишней
              возни с отдельными сервисами.
            </p>
          </div>
        </div>

        <div className="landing-product-details">
          {PRODUCT_DETAILS.map(
            ({
              id,
              name,
              icon,
              title,
              lead,
              features,
              highlight,
              accent,
              previewEditorLabel,
              previewBotLabel,
            }) => {
              const previews = formatPreviews[id];

              return (
                <article
                  key={id}
                  id={`product-${id}`}
                  className={`landing-product-detail landing-product-detail--${accent}`}
                >
                  <div className="landing-product-detail__head">
                    <h3 className="landing-product-detail__name">{name}</h3>
                    <div className="landing-product-detail__icon">{icon}</div>
                    <h4 className="landing-product-detail__title">{title}</h4>
                    <p className="landing-product-detail__lead">{lead}</p>
                  </div>

                  <ul className="landing-product-detail__features">
                    {features.map((feature) => (
                      <li key={feature}>{feature}</li>
                    ))}
                  </ul>

                  {previews ? (
                    <div className="landing-product-detail__previews">
                      <div className="landing-product-detail__preview">
                        <span className="landing-product-detail__preview-label">
                          {previewEditorLabel}
                        </span>
                        {previews.editor}
                      </div>
                      <div className="landing-product-detail__preview">
                        <span className="landing-product-detail__preview-label">
                          {previewBotLabel}
                        </span>
                        {previews.bot}
                      </div>
                    </div>
                  ) : null}

                  <div className="landing-product-detail__highlight">
                    <div className="landing-product-detail__highlight-icon">
                      {highlight.icon}
                    </div>
                    <p>{highlight.text}</p>
                  </div>
                </article>
              );
            }
          )}
        </div>
      </div>
    </section>
  );
}
